import React, { useEffect, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userLiqDataState } from "../../context/userLiqDataState";
import { useLiquidity } from "../../hooks/useLiquidity";
import { formatCompactNumber } from "../../utils/common";

const PoolTabelUserData = ({ t1, t2, pairs, userLiq1, userBondedAmount1, poolAPR1 }: any) => {
  const navigate = useNavigate();
  const handleclick = () => {
    navigate(`/pools/${pairs.pair_name}`, {
      state: { pairs: pairs, token1: t1, token2: t2 },
    });
  };

  const {
    getPoolTotalAmount,
    getPoolUserAmount,
    getPoolAPR,
    getPoolUserBonded,
  } = useLiquidity();
  const [totalLiq, setTotalLiq] = useState("");
  const [userLiq, setUserLiq] = useState("");
  const [poolAPR, setPoolAPR] = useState("");
  const [userBondedAmount, setUserBondedAmount] = useState("");
  const [isloading, setIsLoading] = useState(true);

  const userData = useRecoilValue(userLiqDataState);
  
  const setUserData = useSetRecoilState(userLiqDataState);

  const display = pairs.pair_type === "stable";


  const getPools = async () => {
    const { userAmount } = await getPoolUserAmount(pairs.pair_name);
    setUserLiq(userAmount);
    setIsLoading(false);
    const { totalAmount } = await getPoolTotalAmount(pairs.pair_name);
    setTotalLiq(totalAmount);
    const poolAPR = await getPoolAPR(pairs.pair_name);
    setPoolAPR(poolAPR.apr);

    const { userDollarBonded } = await getPoolUserBonded(pairs.pair_name);
    setUserBondedAmount(userDollarBonded);
    setUserData({
      uAmount: userAmount,
      tAmount: totalAmount,
      uBonded: userDollarBonded,
      apr: poolAPR.apr,
    })
  };

  useEffect(() => {
    setIsLoading(true);
    if(userData.uAmount === ""){
      getPools();
    }
    else {
      setUserLiq(userData.uAmount);
      setIsLoading(false);
      setPoolAPR(userData.apr);
      setTotalLiq(userData.tAmount);
      setUserBondedAmount(userData.uBonded);
    }
  }, []);
   useEffect(()=>{
    const checkuserData = async()=>{
      const { userAmount } = await getPoolUserAmount(pairs.pair_name);
      if(userAmount !== userData.uAmount){
        getPools();
      }
    }
    checkuserData();
  }, [])
  if (!Number(userLiq)) {
    return <></>;
  } else
    return (
      <>
        {isloading ? (
          <>
            <div className="display_pool">
              <SkeletonTheme baseColor="#6046D2" highlightColor="#A500A8">
                {/* <h1>
        <Skeleton width="190px" height="10px"/>
        </h1> */}
                <p>
                  <Skeleton count={1} width="190px" height="5px" />
                </p>
                <p>
                  <Skeleton count={1} width="190px" height="5px" />
                </p>
                <p>
                  <Skeleton count={1} width="190px" height="5px" />
                </p>
                <p>
                  <Skeleton count={1} width="190px" height="5px" />
                </p>
              </SkeletonTheme>
            </div>
          </>
        ) : (
          <tr className="pool-rows" id={pairs.pair_name} onClick={handleclick}>
            <td>
              <div className="display_pool">
                <div>
                  <img
                    src={t1?.logo_URIs.png}
                    alt="NOimg"
                    height={50}
                    width={50}
                  />
                  <img
                    className="logo-overlap"
                    src={t2?.logo_URIs.png}
                    alt="NOimg"
                    height={50}
                    width={50}
                  />
                </div>
                <div>
                  {t1.display_denom}/{t2.display_denom}
                </div>
                {display ? (
                  <div className="display-tag">
                    <span>stable</span>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </td>
            {/* <td className="numeric-font">${totalLiq}</td>
      <td className="numeric-font">${userBondedAmount}</td> */}
            <td className="numeric-font">${formatCompactNumber(userLiq1)}</td>
            <td className="numeric-font">
              ${formatCompactNumber(userBondedAmount1)}
            </td>
            <td className="numeric-font">{poolAPR1}%</td>
          </tr>
        )}
      </>
    );
};

export default PoolTabelUserData;
